import { render, staticRenderFns } from "./DefectMonitor.vue?vue&type=template&id=808c32fe&scoped=true&"
import script from "./DefectMonitor.vue?vue&type=script&lang=js&"
export * from "./DefectMonitor.vue?vue&type=script&lang=js&"
import style0 from "./DefectMonitor.vue?vue&type=style&index=0&id=808c32fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808c32fe",
  null
  
)

export default component.exports